import client from "shared/utils/axios-config";
import {
  BusinessSettingLogPage,
  BusinessSettings,
  UpdateBusinessPoliciesForm,
} from "shared/types";

// Client-facing policy + display-window settings for the current business
// (resolved from the bearer token). Plain async functions in the v2 style —
// the query/mutation hooks wrap these.

export const getBusinessSettings = async (): Promise<BusinessSettings> => {
  const res = await client.get("/v2/business/settings");
  return res.data.data;
};

export const updateBusinessPolicies = async (
  form: UpdateBusinessPoliciesForm,
): Promise<BusinessSettings> => {
  const res = await client.put("/v2/business/settings/policies", form);
  return res.data.data;
};

// The settings change log, one row per changed field, newest first, paged. `fields` narrows
// it to a subset of settings keys (the Tax page asks for its four).
export const getBusinessSettingLog = async (params: {
  fields?: string[];
  page: number;
  pageSize: number;
}): Promise<BusinessSettingLogPage> => {
  const res = await client.get("/v2/business/settings/log", {
    params: {
      fields: params.fields?.length ? params.fields.join(",") : undefined,
      page: params.page,
      page_size: params.pageSize,
    },
  });
  return res.data.data;
};
